import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import pinia from './store'
import './permission'
import '@/assets/reset.css'
import '@/assets/css/icon.css'

import 'element-plus/dist/index.css'
import mavonEditor from 'mavon-editor'
import 'mavon-editor/dist/css/index.css'
import permission_fn from '@/permission/permission'
import { fn_highlight } from '@/directives/height'
import copyDirective from '@/directives/copy';
import dragColumnDirective from '@/directives/dragColumn';
import { useTimStore } from '@/store/tim'
// Import Swiper styles
import 'swiper/css'
import componentsRegister from './plugins/componentsRegister'
import { TUIComponents, TUIChatKit } from './TUIKit'
import { TUILogin } from '@tencentcloud/tui-core'
import TencentCloudChat from '@tencentcloud/chat';
import { watch } from './TUIKit/adapter-vue'
import '@/assets/css/element-plus-color.scss'
import TinymceEditor from "@/components/tinymce.vue";
import { dragTable } from '@/util/common';
import TableDragDrop  from '@/directives/tabledragdrop';


let TimStore = useTimStore();
console.log('isLoginIM', TimStore.isLoginIM.value, TimStore)
const debounce = (fn: Function, delay: number) => {
  let timer: ReturnType<typeof setTimeout>
  return function (this: any) {
    const context = this
    const args = arguments
    clearTimeout(timer)
    timer = setTimeout(function () {
      fn.apply(context, args)
    }, delay)
  }
}
const _ResizeObserver = window.ResizeObserver
window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
  constructor(callback: ResizeObserverCallback) {
    callback = debounce(callback, 16)
    super(callback)
  }
}
const app = createApp(App)

app.config.globalProperties.$dragTable = dragTable;
TUIChatKit.components(TUIComponents, app)
// TUIChatKit init
TUIChatKit.init()
TimStore.BLKTIMLogin();

// watch((TimStore.isLoginIM.value), (val) => {
//   if (val) {
   
//   }
// },{immediate:true})

// setTimeout(() => {
//   if(TimStore.isLoginIM.value){
//     const { chat } = TUILogin.getContext();
//     console.log("chat--->", chat)
//     let onSdkNotReady = function (event: any) {
//       console.log("sdknotready哭唧唧");
//       localStorage.removeItem('token_blk');
//       router.push('/login')
//     };
//     chat.on(TencentCloudChat.EVENT.SDK_NOT_READY, onSdkNotReady);
//   }
// }, 2000);

app.directive('permission', permission_fn)
app.directive('highlight',fn_highlight)
app.directive('copy', copyDirective);
app.directive('table-drag-drop', TableDragDrop);
app.directive('drag-column', dragColumnDirective)
app.config.globalProperties.$dragTable = dragTable;
app.use(pinia).use(router).use(componentsRegister).use(mavonEditor).mount('#app')
